import { useState, useEffect } from "react";
import moment from "moment";

const CountdownTimer = ({ createdAt }) => {
  const [timeElapsed, setTimeElapsed] = useState("");

  useEffect(() => {
    if (!createdAt) {
      setTimeElapsed("");
      return; // If no createdAt, don't start timer
    }

    const interval = setInterval(() => {
      const istTime = moment(createdAt).subtract(5, "hours").subtract(30, "minutes");
      const now = moment();
      const duration = moment.duration(now.diff(istTime));
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      if (duration.asMilliseconds() < 0) {
        // Future time? show empty
        setTimeElapsed("");
      } else {
        setTimeElapsed(
          days > 0
            ? `${days}d ${hours}h ${minutes}m ${seconds}s`
            : `${hours}h ${minutes}m ${seconds}s`
        );
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return (
    <span className="flex flex-1">
      {timeElapsed ? `: ${timeElapsed}` : ": ---"}
    </span>
  );
};

export default CountdownTimer;
